import React from "react";
import "../../css/header-menu/ContactPage.css";
import Header from "../Home/header";
import Footer from "../Home/footer";

function ContactPage() {
    return (
        <>
            <Header />
            <div className="contact-container">
                {/* Merkez Fabrika */}
                <div className="contact-row">
                    <iframe
                        className="contact-map"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3129.4566417423625!2d38.19827989999999!3d38.3384117!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x407631d796c8e379%3A0x872ddaf7e97baa7a!2zRG_En2FuYXRlxZ8gRWxla3RyaWs!5e0!3m2!1str!2str!4v1734088340002!5m2!1str!2str"
                        allowFullScreen
                        loading="lazy"
                        title="Merkez Fabrika Map"

                    ></iframe>
                    <div className="contact-info">
                        <h3>Merkez Fabrika</h3>
                        <p><strong>Adres:</strong><br /> 1. Organize Sanayi Bölgesi 1.Cadde No:3<br /> Yeşilyurt/Malatya</p>
                        <p><strong>Telefon:</strong><br /> 0422 237 51 97<br /> 0422 323 51 13<br /> 0422 323 51 18</p>
                        <p><strong>E-Mail:</strong><br /> info@doganates.com<br /> dapsarj@doganates.com<br /></p>
                    </div>
                </div>

                {/* İhracat Ofisi */}
                <div className="contact-row">
                    <iframe
                        className="contact-map"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3129.4566417423625!2d38.19827989999999!3d38.3384117!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x407631d796c8e379%3A0x872ddaf7e97baa7a!2zRG_En2FuYXRlxZ8gRWxla3RyaWs!5e0!3m2!1str!2str!4v1734088340002!5m2!1str!2str"
                        allowFullScreen
                        loading="lazy"
                        title="Merkez Fabrika Map"
                    ></iframe>
                    <div className="contact-info">
                        <h3>İhracat Ofisi</h3>
                        <p><strong>Adres:</strong><br /> 1. Organize Sanayi Bölgesi 1.Cadde No:3<br /> Yeşilyurt/Malatya</p>
                        <p><strong>GSM:</strong><br /> 0539 512 84 14<br /> 0533 490 84 44</p>
                        <p><strong>E-Mail:</strong><br /> export@doganates.com</p>
                    </div>
                </div>

                {/* İstanbul Şube */}
                <div className="contact-row">
                    <iframe
                        className="contact-map"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3008.402038752079!2d28.970449100000003!3d41.0602038!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab76db7926bf1%3A0xfbcf9a128d013d94!2sDoğanateş Elektrik - DAP Pano İstanbul Şube!5e0!3m2!1str!2str!4v1734088407986!5m2!1str!2str"
                        allowFullScreen
                        loading="lazy"
                        title="İstanbul map Fabrika Map"
                    ></iframe>
                    <div className="contact-info">
                        <h3>İstanbul Şube</h3>
                        <p><strong>Adres:</strong><br /> Perpa Ticaret Merkezi A Blok Kat:11<br /> No:1320 Okmeydanı/Şişli</p>
                        <p><strong>Telefon:</strong><br /> +90 212 392 93 30<br /></p>
                        <p><strong>E-Mail:</strong><br /> dapsarj@doganates.com</p>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default ContactPage;
